import { makeStyles } from '@material-ui/core';
import { porcelain } from '../../../../../abstracts/colours';
import { fonts } from '../../../../../abstracts/constants';

export const useStyles = makeStyles({
  paper: {
    width: '320px',
    borderRadius: '10px',
    border: `solid 2px ${porcelain}`,
  },
  titleRoot: {
    padding: '24px 24px 16px',
    '& .MuiTypography-h6': {
      fontFamily: fonts.sourceSansPro,
      fontSize: '18px',
      fontWeight: 'bold',
      lineHeight: 'normal',
      letterSpacing: '0.15px',
    },
  },
  contentRoot: {
    padding: '0 24px',
  },
  contentTextRoot: {
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    marginBottom: '18px',
    fontFamily: fonts.sourceSansPro,
    fontSize: '16px',
    lineHeight: '1.5',
    letterSpacing: '0.25px',
    color: 'rgba(0, 0, 0, 0.6)',
  },
  actionsRoot: {
    padding: '16px 16px 24px',
  },
});
